const API_URL = {
  AUTH: {
    REFRESH: "token/refresh",
  },
  CATEGORY_MANAGEMENT: {
    JOB_CATEGORY: {
      ADMIN_JOB_CATEGORY: "admin/job-category",
      ADMIN_VIEW_SKILL_CATEGORY: "admin/job-category",
      DELETE_JOB_CATEGORY: "admin/job-category/",

      EDIT_JOB_CATEGORY: "admin/job-category/",
      GET_JOB_CATEGORY: "admin/job-categories",
    },
    JOB_SKILL: {
      ADD_JOB_SKILL: "admin/skill",
      DELETE_JOB_SKILL: "/admin/skill/",
      GET_JOB_SKILL: "admin/skills",
      UPDATE_JOB_SKILL: "/admin/skill/",
    },

    MANAGE_SOFTWARE: {
      ADD_SOFTWARE: "/admin/software",
      GET_SOFTWARE_LIST: "/admin/softwares",
      PUT_SOFTWARE: "/admin/software/",
    },
    SPECIALITY_SKILL: {
      ADD_SPECIALITY_SKILL: "/admin/speciality",
      GET_SPECIALITY_SKILL_LIST: "/admin/specialities",
      PUT_SPECIALITY_SKILL: "/admin/speciality/",
    },
  },
  CHILD_OFFICE: {
    LINK_VALIDATE: "/admin/office/{officeUuid}/child/link",
    MERGE_VALIDATE: "/admin/office/{officeUuid}/child/merge",
  },
  CONTACT_VIEW: {
    ADD_CONTACT_OFFICE: "admin/office/{officeUuid}/contact",
    EDIT_EMAIL: "admin/office/{officeUuid}/email",
    GET_CONTACT_VIEW: "admin/office/officeUuid/contacts",
    GET_FULL_CONTACT: "admin/office/{officeUuid}/contact/full-permission",
    GET_TITLE_WITH_TYPE: "admin/office/contact/titles?type=",
    GET_TITLE: "admin/office/contact/titles",
    REMOVE_CONTACT: "admin/office/{officeUuid}/contact/{contactUuid}/remove",
    SWITCH_CONTACT: "admin/office/{officeUuid}/switch-primary",
    UPDATE_OFFICE: "admin/office/{officeUuid}/contact/{contactUuid}",
    SWITCH_AP_CONTACT: "admin/office/{officeUuid}/switch-ap",
    UPDATE_CONTACT_ACTIVITY_STATUS: "admin/office/contact/activity-status",
    GET_CONTACT_FIND: "/admin/office/{officeUuid}/contact/find",
    ADD_AP_CONTACT: "/admin/office/{officeUuid}/ap-contact",
  },
  COMMON: {
    CITY: "country/us/cities?city=",
    COMMON_INFO: "admin/common-info?type=",
    GET_CITY_DETAILS: "country/us/city/",
    LOG_NOTE: "/admin/note/{noteUuid}/logs",
    EMAIL_VALIDATE: "/app/validate-email",
    MARK_AS_INVALID: "admin/profile/email-status",
    PROSPECT_MARK_AS_INVALID: "admin/prospect/email/status",
    NOTIFICATIONS: "notifications",
    NOTIFICATION: "notification/",
  },
  DASHBOARD: {
    GET_DASHBOARD_DATA: "admin/dashboard",
    JOB_REDIRECTION: "notification",
    OFFICE_JOB_CANCELLATION: "admin/job/office/cancelled-list",
    PROFESSIONAL_JOB_CANCELLATION: "admin/job/professional/cancelled-list",
  },
  DENTAL_OFFICE: {
    GET_JOB_HISTORY: "admin/job/office/{officeUuid}",
    GET_OFFICE_DATA: "admin/office/{officeUuid}/profile",
    GET_OFFICE_USERS: "/admin/offices",
    GET_PAY_SCALE: "/admin/pay-scales",
    GET_VIEW_OFFICE: "admin/office/",
    OFFICE_REJECT_APPROVE: "admin/office/",
    UPDATE_DOB: "admin/profile/dob/",
    EDIT_SECONDARY_EMAIL: "admin/profile/{officeUuid}/additional-info",
    EDIT_WORKING_HOURS: "/admin/office/{officeUuid}/job-day-setting",
  },
  DENTAL_PROFESSIONAL: {
    EDIT_EMAIL: "admin/professional/{professionalUuid}/email",
    GET_CONTRACT: "professional/contracts",
    GET_JOB_HISTORY_PROFESSIONAL: "admin/job/professional/{professionalUuid}",
    GET_PROFESSIONAL_USERS: "/admin/professionals",
    GET_USER_ALL_DATA: "admin/professional/",
    PROFESSIONAL_ACCOUNT: "admin/professional/",
    REJECT_APPROVE: "admin/professional/",
    UPDATE_DOB: "admin/profile/dob/",
    UPDATE_MOBILE: "admin/profile/mobile/",
    UPDATE_SALUTATION: "admin/professional/{professionalUuid}/profile-settings",
    UPDATE_ADP: "admin/profile/details/",
    VERIFY_IDENTIFICATION:
      "admin/professional/{professionalUuid}/profile-settings",
  },
  INVOICE: {
    GET_INVOICE_LIST: "/admin/invoices",
    GET_INVOICE_DETAILS: "/admin/invoice/",
    GET_INVOICE_STATEMENT: "/admin/invoice/monthly-statement",
    GET_MASTER_INVOICE_LIST: "/admin/invoice/list",
    GET_ON_ACCOUNT_LIST: "/admin/invoice/on-account",
    GET_CREDIT_MEMO_LIST: "/admin/invoice/credit-memos",
    GET_TIME_SHEET_PAYMENTS: "/admin/timesheet/payments",
    MARK_TIMESHEET_LATE_PAYMENT: "/admin/timesheet/late-submitted/mark-payment",
    MARK_TIMESHEET_PAYMENT: "/admin/timesheet/{professionalUuid}/mark-as-paid",
    CREATE_MANUAL_INVOICE: "/admin/invoice",
    CREATE_CREDIT_MEMO: "/admin/invoice/credit-memo",
    DEDUCT_CREDIT_MEMO: "admin/invoice/credit-memo/",
    ADD_ADDENDUM: "/admin/office/addendum",
    SIGN_ADDENDUM: "/admin/office/sign-addendum",
    GET_PROFESSIONAL_TIMESHEET_JOB:
      "/admin/professional/{professionalUuid}/timesheet-job",
    GET_JOB_TIMESHEETS: "/admin/invoice/{jobUuid}/timesheet/{invoiceUuid}",
    GET_INVOICE_HISTORY: "/admin/invoice/{invoiceUuid}/revisions",
    CHILD_INVOICE_ADJUST:
      "/admin/invoice/{invoiceUuid}/child-office/{officeUuid}",
  },
  JOB_CALANDER: {
    GET_OFFICE_CALANDER: "admin/job-calendar/office",
    GET_JOB_CALANDER: "admin/job-calendar",
    GET_PROFESSIONAL_CALANDER: "admin/job-calendar/professional",
  },
  JOBS: {
    CANCEL_ADMIN_JOB: "admin/job/{jobUuid}/cancel",
    GET_OFFICE_LIST: "/admin/offices/find",
    PATCH_JOBS: "admin/job/",
    POST_JOB_BY_ADMIN: "admin/job",
    POSTED_JOBS: "admin/jobs",
    UPDATE_JOB_BY_ADMIN: "admin/job/{jobUuid}",
  },
  JOB: {
    ASSIGN_APPLICANT: "admin/job/",
    FULL_FILL: "admin/job/professional/fullfill",
    GET_BILL_DETAILS: "/admin/job/",
    GET_BILL_RATE: "/admin/job/{uuid}/bill-rate",
    GET_JOB_DATA: "/admin/job/",
    GET_JOB_DATA_PROFESSIONAL: "/admin/job/",
    GET_JOB_LOGS: "/admin/job/{uuid}/activities",
    GET_TIMESHEET: "/admin/job/timesheet/",
    FIND_PROSPECTS: "/admin/job/",
    ASSIGN_RECRUITER: "/admin/assign-recruiter",
    GET_RECRUITERS: "/admin/recruiting-user",
    GET_RECRUITERS_JOB: "/admin/recruiters",
    GET_MY_ASSIGNMENTS_JOB: "/admin/recruiter/{userId}/jobs",
    GET_NOTES: "/admin/job/{jobUuid}/notes",
    ADD_NOTE: "/admin/job/note",
    EDIT_NOTE: "/admin/job/note/{noteUuid}",
    UN_ASSIGN_RECRUITER: "/admin/unassign-recruiter",
  },
  NOTES: {
    GET_NOTES: "admin/notes",
    OFFICE_DNS_NOTE: "admin/office/{uuid}/dns-notes",
    POSTPONE_MARK_NOTE: "admin/note/{noteUuid}",
    PROFESSIONAL_DNS_NOTE: "admin/professional/{uuid}/dns-notes",
    VIEW_NOTE: "admin/note/{noteUuid}",
    DNS_REVERT: "admin/note/dns-revert",
    GET_DNS_LOGS: "admin/note/{taggedUserUuid}/{taggedByUuid}/dns-logs",
    GET_CONTACT_FIND: "/admin/note/contact/find",
  },
  OFFICE: {
    CHILD_OFFICE: "/admin/office/{officeUuid}/child",
    CONTRACT_PREVIEW:
      "admin/office/contract/preview/{officeUuid}/{contractUuid}",
    DELETE_ACCOUNT: "admin/office/{officeUuid}",
    DELETE_CHILD_ACCOUNT: "admin/office/child/{officeUuid}",
    DOWNLOAD_REPORT: "/admin/report?format=xlsx&",
    ENABLE_DISABLE_ACCOUNT: "admin/office/{officeUuid}/account",
    GET_ACCOUNT_ACTIVITY_HISTORY: "admin/office/{officeUuid}/account-activity",
    GET_CHILD_OFFICE: "/admin/office/{officeUuid}/child-offices",
    OFFICE_PROFILE: "admin/office",
    UPDATE_OFFICE: "admin/office/{uuid}/profile",
    GET_OFFICE_INVOICES: "admin/office/{officeUuid}/invoices",
    GET_INVOICING_SETUP: "admin/office/{officeUuid}/invoicing-setup",
    PATCH_INVOICING_SETUP: "admin/office/{officeUuid}/invoicing-setup",
    PATCH_INVOICE_COPY_REFERENCE:
      "admin/child-office/{officeUuid}/invoice-copy-preference",
    PATCH_CONTACT_FIELDS: "admin/office/{officeUuid}/contact-fields",
    PATCH_OFFICE_MOBILE: "admin/office/{officeUuid}/mobile",
  },
  OFFICE_NOTES: {
    GET_OFFICE_NOTES: "admin/office/{officeUuid}/notes",
    ADD_OFFICE_NOTES: "admin/office/note",
    EDIT_OFFICE_NOTES: "admin/office/note/",
  },
  PAY_RANGE: {
    CREATE_PAY_RANGE: "admin/pay-scale",
    CREATE_TRANSPARENCY_PAY_SCALE: "admin/pay-scale/transparency",
    GET_TRANSPARENCY_PAY_SCALE: "admin/pay-scale/transparency/",
    GET_PAY_RANGE_DATA: "/admin/pay-scale",
    PATCH_PAY_RANGE_DATA: "/admin/pay-scale/level/",
    GET_PAY_SCALES: "/admin/pay-scales",
    GET_PAY_SCALE: "/admin/pay-scale/",
    GET_OFFICE_PAY_RANGE_DATA: "/admin/pay-scale/office/",
    GET_PAY_SCALE_OFFICES: "admin/pay-scale/{payScaleUuid}/offices",
    SWITCH_PAY_SCALE: "admin/office/{officeUuid}/pay-scale",
    GET_DIRECT_HIRE_FEES: "/admin/pay-scale/{payScaleUuid}/direct-hire-fees",
    PATCH_DIRECT_HIRE_FEES: "/admin/pay-scale/{payScaleUuid}/direct-hire-fees",
    PATCH_TRANSPARENCY_HOURLY_ESCALATIONS:
      "admin/pay-scale/transparency/{payScaleUuid}/hourly-escalations",
    PATCH_TRANSPARENCY_FULL_SERVICE_FEES:
      "admin/pay-scale/transparency/{payScaleUuid}/full-service-fees",
    PATCH_TRANSPARENCY_PLACEMENT_SUPPORT_FEES:
      "admin/pay-scale/transparency/{payScaleUuid}/placement-support-fees",
    PATCH_TRANSPARENCY_PAYROLL_BURDEN_PERCENTAGE:
      "admin/pay-scale/transparency/{payScaleUuid}/payroll-burden-percentage",
  },
  PROFILE_COMMON_DATA: "admin/common-info",
  TIMESHEET: {
    APPROVE_REJECT_TIMESHEET: "admin/timesheet/{timesheetUuid}/status",
    GET_TIMESHEET_DETAILS: "admin/timesheet/",
    GET_TIMESHEET_LIST: "admin/timesheets",
    GET_LATE_SUBMIT_TIME_SHEET: "/admin/timesheet/late-submitted",
    GET_PROFESSIONAL_TIMESHEET_LIST:
      "admin/professional/{professionalUuid}/timesheet",
    UPDATE_PROFESSIONAL_TIMESHEET: "admin/professional/timesheet/{uuid}",
  },
  TIMESHEET_DISPUTE: {
    GET_TIMESHEET_DISPUTE: "admin/timesheet/disputes",
    TIMESHEET_DISPUTE_SOLVE: "admin/timesheet/{timesheetUuid}/solve-dispute",
  },
  TIME_ZONE: {
    TIMEZONE: "timezones",
  },
  PROFESSIONAL: {
    CONTRACT_PREVIEW: "admin/professional/contract/preview/{contractUuid}",
    DELETE_ACCOUNT: "admin/professional/{professionalUuid}",
    ENABLE_DISABLE_ACCOUNT: "admin/professional/{professionalUuid}/account",
    GET_ACCOUNT_ACTIVITY_HISTORY:
      "admin/professional/{professionalUuid}/account-activity",
  },
  PROSPECT: {
    DELETE_PROSPECT: "admin/prospect/",
    DO_NOT_DISTURB: "admin/prospect/",
    GET_PROSPECT_LIST: "/admin/prospects",
    ADD_PROSPECT: "admin/prospect/",
    EDIT_PROSPECT: "admin/prospect/",
    GET_PROSPECT: "/admin/prospect/",
    GET_NOTES: "/admin/prospect/{prospectUuid}/notes",
    ADD_NOTES: "/admin/prospect/{prospectUuid}/note",
    UPDATE_NOTES: "/admin/prospect/note/",
    LINK: "/admin/prospect/{prospectUuid}/link",
    GET_ALL_PROFESSIONAL_LIST: "/admin/professionals/find",
    GET_PROSPECT_LOGS: "/admin/prospect/{prospectUuid}/logs",
    MARK_AS_HOT_LEAD: "/admin/prospect/{prospectUuid}/hot-lead",
    GET_PROSPECT_CONTACTS: "/admin/prospect/{prospectUuid}/contacts",
    ADD_PROSPECT_CONTACT: "/admin/prospect/{prospectUuid}/contact",
    EDIT_PROSPECT_CONTACT: "/admin/prospect/contact/{contactUuid}",
    DELETE_PROSPECT_CONTACT: "/admin/prospect/contact/{contactUuid}/remove",
    PROSPECT_CONTACT_ACTIVITY_STATUS: "/admin/prospect/contact/activity-status",
    SWITCH_PROSPECT_CONTACT: "/admin/prospect/contact/activity-status",
    GET_CONTACT_FIND: "/admin/prospect/{prospectUuid}/contact/find",
    ADD_OFFICE_INFO: "admin/prospect/{prospectUuid}/office",
    DOWNLOAD_IMPORT_TEMPLATE: "/admin/prospect/import/template/{typeUuid}",
    IMPORT_EXCEL: "/admin/prospect/import",
    IMPORT_LOG: "/admin/prospect/import/logs",
    IMPORT_ERRORS: "/admin/prospect/import/{uuid}/errors",
    IMPORT_INITIATE: "/admin/prospect/import/{uuid}/initiate",
    IMPORT_FILE: "/admin/prospect/import/{uuid}/file",
  },
  TIMESHEET_EXPENSES: {
    CREATE: "admin/timesheet/{timesheetUuid}/expense",
  },
  PROFESSIONAL_NOTES: {
    GET_PROFESSIONAL_NOTES: "admin/professional/{professionalUuid}/notes",
    ADD_PROFESSIONAL_NOTES: "admin/professional/note",
    EDIT_PROFESSIONAL_NOTES: "admin/professional/note/",
  },
  PROFILE: {
    CONTRACT_DELETE_OFFICE: "admin/office/{officeUuid}/document/{uuid}",
    CONTRACT_DELETE_PROFESSIONAL:
      "admin/professional/{officeUuid}/document/{uuid}",
    CONTRACT_UPLOAD: "/admin/upload",
    PROFESSIONAL_PROFILE: "admin/professional",
    FILE_UPLOAD: "/profile/upload",
    SEND_RESET_PASSWORD: "/admin/send-reset-email",
    UPDATE_PROFESSIONAL: "admin/professional/{uuid}/profile",
    VERSION_PROFESSIONAL: "admin/professional/version/",
    VALIDATE_EMAIL: "/admin/email/validate",
    VALIDATE_EMAIL_AND_MOBILE: "/admin/validate",
    VALIDATE_PRIMARY_ACCOUNT: "/admin/primary-contact/validate",
    GET_STATE_DETAILS: "/country/us/state",
    CHECK_LICENSE: "/admin/professional/license-check",
    VALIDATE_AP_ACCOUNT: "/admin/ap-contact/validate",
    PROFILE_SUBMIT: "/admin/profile/{userUuid}/submit",
  },
  REFERRAL_MANAGEMENT: {
    CREATE_REFERRAL_CATEGORIES: "/admin/referral-category",
    CREATE_REFERRAL_SUB_CATEGORIES: "/admin/referral-subcategory",
    GET_REFERRAL_CATEGORIES: "/admin/referral-categories",
    GET_REFERRAL_SUB_CATEGORIES:
      "/admin/referral-category/{parentCategoryUuid}",
    MAP_REFERRAL_CATEGORIES: "/admin/referral-category/assign",
    UPDATE_REFERRAL_CATEGORIES:
      "/admin/referral-category/{categoryUuid}/update",
  },
  REVENUE_REPORT: {
    GET_REPORT: "/admin/revenue-report",
    GET_MANUAL_INVOICE_REPORT:
      "/admin/revenue-report/{userUuid}/manual-invoice",
  },
  SETTINGS: {
    AUTO_PUBLISH_SETTING: "admin/auto-publish-setting",
  },
  SENSE: {
    CONTACT_SENSE: "/admin/office/{officeUuid}/contact/{contactUuid}/messages",
    PROFESSIONAL_SENSE: "/admin/professional/{professionalUuid}/messages",
    PROSPECT_SENSE: "/admin/prospect/{prospectUuid}/messages",
    UPDATE_RECRUITER_STATUS: "/admin/profile/recruiter-status",
    UPDATE_PROSPECT_RECRUITER_STATUS:
      "/admin/prospect/profile/recruiter-status",
    GET_RECRUITER_LOGS: "admin/recruiter-status/{userUuid}/logs",
    GET_PROSPECT_RECRUITER_LOGS:
      "admin/prospect/{prospectUuid}/recruiter-status/logs",
  },
  USER: {
    ADD_ADMIN_USER: "admin/user",
    ADMIN_CHANGE_PASSWORD: "profile/change-password",
    ADMIN_LOGIN: "auth/admin/login",
    ADMIN_PROFILE: "admin/profile",
    EDIT_ADMIN_USER: "admin/user/",
    GET_ADMIN_USER: "admin/users",
    GET_ADMIN_USERS: "admin/admin-users",
    GET_ADMIN: "admin/user/",
    GET_ADDITIONAL_CONTACT_INFO:
      "admin/office/{officeUuid}/contact/{contactUuid}/additional-info",
    GET_OFFICE_DOCUMENTS: "/admin/office/{uuid}/documents",
    GET_PROFESSIONAL_DOCUMENTS: "/admin/professional/{uuid}/documents",
    GET_OFFICE_PREVIEW: "/admin/office/contract/{uuid}/preview",
    GET_PROFESSIONAL_PREVIEW: "/admin/professional/contract/{uuid}/preview",
    GET_ROLE_MODULES: "admin/modules",
    PROFILE_COMMON_DATA: "admin/common-info",
    RELEASE_CONTRACT_OFFICE: "/admin/office/{uuid}/release-contract",
    RELEASE_CONTRACT_PROFESSIONAL:
      "/admin/professional/{uuid}/release-contract",
    REFRESH_TOKEN: "api/token/refresh",
    REMOVE_ADMIN_USER: "admin/user/{uuid}/remove",
    RESET_EMAIL: "auth/send-reset-email",
    RESET_PASSWORD: "auth/password",
    SAVE_ADDITIONAL_INFO: "admin/profile/{uuid}/additional-info",
    SAVE_ADDITIONAL_CONTACT_INFO:
      "admin/office/{officeUuid}/contact/{contactUuid}/additional-info",
    VALID_TOKEN: "auth/verify/",
    UPDATE_PAYMENT_URL: "admin/office/{uuid}/payment-method",
    UPLOAD_CONTRACT_OFFICE:
      "/admin/office/{officeUuid}/contract/{contractUuid}/meta-data",
    UPLOAD_CONTRACT_PROFESSIONAL:
      "/admin/professional/{professionalUuid}/contract/{contractUuid}/meta-data",
  },
};
export default API_URL;
